import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import * as pbi from 'powerbi-client';
declare var powerbi: any;

@Component({
  selector: 'app-reporte-ventas-generalmm',
  templateUrl: './reporte-ventas-generalmm.component.html',
  styleUrls: ['./reporte-ventas-generalmm.component.css']
})
export class ReporteVentasGeneralmmComponent implements OnInit {
  @ViewChild('embeddedReport')
  embeddedReport: ElementRef;
  config: any;
  screenHeight: number;

  
  constructor(public sanitizer: DomSanitizer,private httpClient: HttpClient) { }

  ngOnInit() {

  }

  buildReport()
  {

    this.screenHeight = (window.screen.height);  
    const _httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      })
    };
    var body = {
      workspaceId: "0f6677e4-5db7-4f28-9a93-157c503e0952",
      reportId: "58730914-948c-4ada-b08e-56cd39af05bd",
      filters: ""
    }
    this.httpClient.post<any>(environment.apiBIUrl + "tableros/generar",body,_httpOptions ) //https://localhost:5001/weatherforecast
    .subscribe(config => {
      this.config = config;
      //debugger;
      //const model = window['powerbi-client'].models;
      const model = pbi.models;
      const embedConfig = {
        type: 'report',
        tokenType: model.TokenType.Embed,
        accessToken: this.config.token,
        embedUrl: this.config.embedUrl,
        permissions: model.Permissions.Read,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false
        }
      };
      powerbi.embed(this.embeddedReport.nativeElement, embedConfig);
    });
    
  }
}
